import {
  FETCH_CURRENT_BOOKING,
  UPDATE_BOOKING_STEP,
  UPDATE_BOOKING_USERS,
  UPDATE_BOOKING_SUGGESTED_USERS,
  UPDATE_ACTIVE_USER,
  UPDATE_ACTIVE_ROOT_CATE,
  UPDATE_ACTIVE_SUB_CATE,
  UPDATE_STYLIST_MAPPINGS,
  UPDATE_AVAILABLE_STYLISTS,
  UPDATE_STYLIST_SETTINGS,
  UPDATE_STYLIST_AVAILABLE_TIMES,
  UPDATE_BOOKING_NOTES,
  UPDATE_BOOKING_CREDIT_CARD,
  UPDATE_ACTIVE_ROOT_CATE_MOBILE,
  UPDATE_BOOKING_HISTORY,
  UPDATE_NEW_USER_FLAG,
} from "../constants";
import { createUser } from "../types/user";

type BookingActionType = 'BOOKING/UPDATE_STEP'
  | 'BOOKING/FETCH_CURRENT_BOOKING'
  | 'BOOKING/UPDATE_BOOKING_HISTORY'
  | 'BOOKING/UPDATE_USERS'
  | 'BOOKING/BOOKING_SUGGESTED_USERS'
  | 'BOOKING/UPDATE_ACTIVE_USER'
  | 'BOOKING/UPDATE_NEW_USER_FLAG'
  | 'BOOKING/UPDATE_ACTIVE_ROOT_CATE_MOBILE'
  | 'BOOKING/UPDATE_ACTIVE_ROOT_CATE'
  | 'BOOKING/UPDATE_ACTIVE_SUB_CATE'
  | 'BOOKING/UPDATE_STYLIST_MAPPINGS'
  | 'BOOKING/UPDATE_AVAILABLE_STYLISTS'
  | 'BOOKING/UPDATE_STYLIST_SETTINGS'
  | 'BOOKING/UPDATE_STYLIST_AVAILABLE_TIMES'
  | 'BOOKING/UPDATE_NOTES'
  | 'BOOKING/UPDATE_CREDIT_CARD'
  ;
interface BookingAction {
  type: BookingActionType;
  payload: any;
}

const defaultUsers = [
  createUser({ user_id: 1, can_delete: false, can_select_service: true, can_select_stylist: true, can_select_date_time: true }),
];

export const defaultState = {
  users: defaultUsers,
  suggestedUsers: {},
  activeUserId: 1,
  newUserFlag: null,

  activeRootCateMobile: null,
  activeRootCate: null,
  activeSubCate: null,

  mappedStylists: {},
  availableStylists: [],
  availableTimes: [],
  stylistSettings: null,

  bookingHistory: {},
  currentBooking: null,
  bookingNotes: null,
  creditCard: {},
};

export function bookingReducer(state = defaultState, action: BookingAction) {
  switch (action.type) {
    case UPDATE_ACTIVE_USER:
      return { ...state, activeUserId: action.payload };

    case UPDATE_NEW_USER_FLAG:
      return { ...state, newUserFlag: action.payload };

    case UPDATE_BOOKING_HISTORY:
      return { ...state, bookingHistory: action.payload };

    case FETCH_CURRENT_BOOKING:
      return { ...state, currentBooking: action.payload };

    case UPDATE_BOOKING_STEP:
      return { ...state, step: action.payload };

    case UPDATE_BOOKING_USERS:
      return { ...state, users: action.payload };

    case UPDATE_BOOKING_SUGGESTED_USERS:
      return { ...state, suggestedUsers: action.payload };

    case UPDATE_ACTIVE_ROOT_CATE:
      return { ...state, activeRootCate: action.payload };

    case UPDATE_ACTIVE_ROOT_CATE_MOBILE:
      return { ...state, activeRootCateMobile: action.payload };

    case UPDATE_ACTIVE_SUB_CATE:
      return { ...state, activeSubCate: action.payload };

    case UPDATE_AVAILABLE_STYLISTS:
      return { ...state, availableStylists: action.payload };

    case UPDATE_STYLIST_MAPPINGS:
      return { ...state, mappedStylists: { ...state.mappedStylists, ...action.payload } };

    case UPDATE_STYLIST_SETTINGS:
      return { ...state, stylistSettings: action.payload };

    case UPDATE_STYLIST_AVAILABLE_TIMES:
      return { ...state, availableTimes: action.payload };

    case UPDATE_BOOKING_NOTES:
      return { ...state, bookingNotes: action.payload };

    case UPDATE_BOOKING_CREDIT_CARD:
      return { ...state, creditCard: action.payload };

    default:
      return state;
  }
}
